export default {
  googleFont: 'https://fonts.googleapis.com/css?family=Annie+Use+Your+Telescope',
  fonts: {
    body: '"Annie Use Your Telescope", cursive'
  },
  styles: {
    root: {
      textAlign: 'center'
    },
    pre: {
      textAlign: 'left'
    }
  }
};